export default "__VITE_ASSET__CA8wFntt__"